export const invoicesIt: Record<string, string> = {
  'invoices.totalInvoiced': 'Totale Fatturato',
  'invoices.totalPaid': 'Totale Pagato',
  'invoices.outstanding': 'In Sospeso',
  'invoices.availableToInvoice': 'Disponibile per Fatturazione',
  'invoices.mainInvoice': 'Fattura Principale',
  'invoices.invoiceNumber': 'Fattura #',
  'invoices.issueDate': 'Data Emissione',
  'invoices.dueDate': 'Data Scadenza',
  'invoices.totalAmount': 'Importo Totale',
  'invoices.amountPaid': 'Importo Pagato',
  'invoices.print': 'Stampa',
  'invoices.recordPayment': 'Registra Pagamento',
  'invoices.paymentRequests': 'Richieste di Pagamento',
  'invoices.printInvoice': 'Stampa Fattura',
  'invoices.printPaymentRequest': 'Stampa Richiesta di Pagamento',
  'invoices.printReceipt': 'Stampa Ricevuta',
  'invoices.amount': 'Importo',
  'invoices.description': 'Descrizione',
  'invoices.allPayments': 'Tutti i Pagamenti',
  'invoices.paymentMethod': 'Metodo di Pagamento',
  'invoices.date': 'Data',
  'invoices.receiptNumber': 'Ricevuta #',
  'invoices.createInvoice': 'Crea Fattura',
  'invoices.createPaymentRequest': 'Crea Richiesta di Pagamento',
  'invoices.archive': 'Archivia',
  'invoices.remaining': 'Rimanente',
  'invoices.paymentRequestCreated': 'Richiesta di Pagamento Creata',
  'invoices.paymentRequestCreatedDescription': 'La richiesta di pagamento è stata creata con successo',
  'invoices.invoiceCreated': 'Fattura Creata',
  'invoices.invoiceCreatedDescription': 'La fattura {number} è stata creata con successo',
  'invoices.paymentAdded': 'Pagamento Aggiunto',
  'invoices.paymentAddedDescription': 'Il pagamento è stato registrato con successo',
  'invoices.refundRecorded': 'Rimborso Registrato',
  'invoices.refundRecordedDescription': 'Il rimborso è stato registrato con successo',
  'invoices.invoicePrinted': 'Fattura Stampata',
  'invoices.invoicePrintedDescription': 'Fattura aperta per la stampa',
  'invoices.paymentRequestOpened': 'Richiesta di Pagamento Aperta',
  'invoices.paymentRequestOpenedDescription': 'Richiesta di pagamento aperta per la stampa',
  'invoices.paymentRequestArchived': 'Richiesta di Pagamento Archiviata',
  'invoices.paymentRequestArchivedDescription': 'La richiesta di pagamento è stata archiviata con successo',
  'invoices.receiptOpened': 'Ricevuta Aperta',
  'invoices.receiptOpenedDescription': 'Ricevuta di pagamento aperta in nuova scheda',
  'invoices.errorLoadingData': 'Impossibile caricare fatture e dati di pagamento',
  'invoices.errorCreatingInvoice': 'Impossibile creare la fattura',
  'invoices.errorCreatingPaymentRequest': 'Impossibile creare la richiesta di pagamento',
  'invoices.errorRecordingPayment': 'Impossibile registrare il pagamento',
  'invoices.errorPrintingInvoice': 'Impossibile stampare la fattura',
  'invoices.errorPrintingPaymentRequest': 'Impossibile stampare la richiesta di pagamento',
  'invoices.errorArchivingPaymentRequest': 'Impossibile archiviare la richiesta di pagamento',
  'invoices.errorOpeningReceipt': 'Impossibile aprire la ricevuta di pagamento',
  'invoices.noInvoiceFound': 'Nessuna fattura trovata per creare la richiesta di pagamento',
  'invoices.mustBeLoggedIn': 'Devi essere loggato per registrare i pagamenti',
  'invoices.noInvoiceYet': 'Nessuna fattura ancora',
  'invoices.createMainInvoice': 'Crea Fattura Principale',
  'invoices.noPaymentRequestsYet': 'Nessuna richiesta di pagamento ancora',
  'invoices.noPaymentsYet': 'Nessun pagamento registrato ancora',
  'invoices.fullyPaid': 'Completamente Pagato',
  'invoices.overpaid': 'Pagamento in Eccesso',
  'invoices.archivePaymentRequest': 'Archivia Richiesta di Pagamento',
  'invoices.archivePaymentRequestConfirm': 'Sei sicuro di voler archiviare questa richiesta di pagamento? Questa azione non può essere annullata.',
  'invoices.editOrder': 'Modifica Ordine',
  'invoices.orderUpdated': 'Ordine aggiornato con successo',
  'invoices.errorUpdatingOrder': "Impossibile aggiornare l'ordine",
  'invoices.discountType': 'Tipo Sconto',
  'invoices.percentage': 'Percentuale',
  'invoices.fixedAmount': 'Importo Fisso',
  'invoices.notesPlaceholder': 'Note interne su questo ordine...',
  'invoices.standalone.title': 'Crea Fattura - Passo {step} di 3',
  'invoices.standalone.step1Description': 'Seleziona un ordine da fatturare',
  'invoices.standalone.step2Description': 'Imposta importo fattura e date',
  'invoices.standalone.step3Description': 'Rivedi e conferma i dettagli della fattura',
  'invoices.standalone.searchPlaceholder': 'Cerca ordini per numero o nome cliente...',
  'invoices.standalone.selectOrder': 'Seleziona Ordine',
  'invoices.standalone.loadingOrders': 'Caricamento ordini...',
  'invoices.standalone.noOrdersMatchingSearch': 'Nessun ordine trovato per la tua ricerca',
  'invoices.standalone.noOrdersAvailable': 'Nessun ordine disponibile per la fatturazione',
  'invoices.standalone.ofTotalRemaining': 'di EUR {total} residui',
  'invoices.standalone.selectedOrder': 'Ordine Selezionato',
  'invoices.standalone.orderLabel': 'Ordine:',
  'invoices.standalone.customerLabel': 'Cliente:',
  'invoices.standalone.availableToInvoiceLabel': 'Disponibile da fatturare:',
  'invoices.standalone.invoiceAmount': 'Importo Fattura',
  'invoices.standalone.amountPlaceholder': '0.00',
  'invoices.standalone.amountExceedsBalance': "L'importo supera il saldo disponibile",
  'invoices.standalone.quickAmounts': 'Importi Rapidi',
  'invoices.standalone.fullBalance': 'Saldo Completo: EUR {amount}',
  'invoices.standalone.halfBalance': 'Metà: EUR {amount}',
  'invoices.standalone.pickDate': 'Seleziona una data',
  'invoices.standalone.invoiceSummary': 'Riepilogo Fattura',
  'invoices.standalone.invoiceAmountLabel': 'Importo Fattura:',
  'invoices.standalone.notSet': 'Non impostata',
  'invoices.standalone.remainingAfterInvoice': 'Residuo dopo questa fattura:',
  'invoices.standalone.draftNotice': 'La fattura verrà creata come bozza. Potrai poi stamparla o segnarla come emessa quando pronta.',
  'invoices.standalone.back': 'Indietro',
  'invoices.standalone.next': 'Avanti',
  'invoices.standalone.fetchOrdersError': 'Impossibile recuperare gli ordini',
  'invoices.standalone.userOrgNotFound': 'Organizzazione utente non trovata',
  'invoices.standalone.invoiceCreatedSuccess': 'Fattura creata con successo',
  'invoices.createDialog.title': 'Crea Fattura - Passo {step} di 2',
  'invoices.createDialog.step1Description': 'Imposta importo fattura e date',
  'invoices.createDialog.step2Description': 'Rivedi e conferma i dettagli della fattura',
  'invoices.createDialog.invoiceAmount': 'Importo Fattura',
  'invoices.createDialog.amountPlaceholder': '0.00',
  'invoices.createDialog.availableToInvoice': 'Disponibile da fatturare: EUR {amount}',
  'invoices.createDialog.amountExceedsBalance': "L'importo supera il saldo disponibile",
  'invoices.createDialog.quickAmounts': 'Importi Rapidi',
  'invoices.createDialog.suggestedAmount': 'Suggerito: EUR {amount}',
  'invoices.createDialog.fullBalance': 'Saldo Completo: EUR {amount}',
  'invoices.createDialog.halfBalance': 'Meta: EUR {amount}',
  'invoices.createDialog.issueDate': 'Data Emissione',
  'invoices.createDialog.dueDate': 'Data Scadenza',
  'invoices.createDialog.pickDate': 'Seleziona una data',
  'invoices.createDialog.invoiceSummary': 'Riepilogo Fattura',
  'invoices.createDialog.invoiceAmountLabel': 'Importo Fattura:',
  'invoices.createDialog.issueDateLabel': 'Data Emissione:',
  'invoices.createDialog.dueDateLabel': 'Data Scadenza:',
  'invoices.createDialog.notSet': 'Non impostata',
  'invoices.createDialog.remainingAfterInvoice': 'Residuo dopo questa fattura:',
  'invoices.createDialog.issuedNotice': 'Una volta creata, questa fattura verra segnata come "Emessa" e potra essere scaricata come PDF. Potrai quindi registrare i pagamenti su questa fattura quando vengono ricevuti.',
  'invoices.createDialog.back': 'Indietro',
  'invoices.createDialog.cancel': 'Annulla',
  'invoices.createDialog.next': 'Avanti',
  'invoices.createDialog.createInvoice': 'Crea Fattura',
  'invoices.printTemplate.logoPlaceholder': 'LOGO',
  'invoices.printTemplate.telLabel': 'Tel.',
  'invoices.printTemplate.faxLabel': 'Fax',
  'invoices.printTemplate.vatLabel': 'P.IVA',
  'invoices.printTemplate.taxCodeLabel': 'C.F.',
  'invoices.printTemplate.documentTitle': 'CONTRATTO DI VENDITA / FATTURA',
  'invoices.printTemplate.invoiceDate': 'Data Fattura',
  'invoices.printTemplate.invoiceNumber': 'Numero Fattura',
  'invoices.printTemplate.customer': 'Cliente',
  'invoices.printTemplate.address': 'Indirizzo',
  'invoices.printTemplate.taxCode': 'Codice Fiscale',
  'invoices.printTemplate.phone': 'Telefono',
  'invoices.printTemplate.firstFitting': 'Prima Prova',
  'invoices.printTemplate.secondFitting': 'Seconda Prova',
  'invoices.printTemplate.deliveryDate': 'Data Consegna',
  'invoices.printTemplate.weddingDate': 'Data Matrimonio',
  'invoices.printTemplate.description': 'Descrizione',
  'invoices.printTemplate.quantity': 'Q.ta',
  'invoices.printTemplate.unitPrice': 'Prezzo Unit. EUR',
  'invoices.printTemplate.lineTotal': 'Totale Riga EUR',
  'invoices.printTemplate.discountPercent': 'Sconto {percent}%',
  'invoices.printTemplate.discount': 'Sconto',
  'invoices.printTemplate.subtotal': 'Subtotale',
  'invoices.printTemplate.tailoring': 'Sartoria / Modifiche',
  'invoices.printTemplate.grandTotal': 'Totale Generale',
  'invoices.printTemplate.depositPaid': 'Caparra Versata',
  'invoices.printTemplate.amountDue': 'Importo Dovuto',
  'invoices.printTemplate.paymentSummary': 'Riepilogo Pagamenti',
  'invoices.printTemplate.legalNotice': 'Non si accettano assegni di conto corrente. I pagamenti devono essere effettuati secondo i termini stabiliti. Gli importi indicati si intendono comprensivi dell\'IVA vigente al momento della fatturazione.',
  'invoices.printTemplate.acceptanceLabel': 'Per accettazione',
  'invoices.printTemplate.customerSignature': 'Firma del Cliente',
  'invoices.printTemplate.companyLabel': 'Per la Ditta',
  'invoices.printTemplate.stampAndSignature': 'Timbro e Firma',

  // Payments
  'payments.title': 'Pagamenti',
  'payments.addPayment': 'Aggiungi Pagamento',
  'payments.amount': 'Importo',
  'payments.method': 'Metodo di Pagamento',
  'payments.date': 'Data Pagamento',
  'payments.notes': 'Note',
  'payments.printReceipt': 'Stampa Ricevuta',
  'payments.downloadReceipt': 'Scarica Ricevuta',
  'payments.receiptNumber': 'Ricevuta #',
  'payments.paymentHistory': 'Storico Pagamenti',
  'payments.customer.subtitle': 'Visualizza lo storico dei tuoi pagamenti e scarica le ricevute.',
  'payments.customer.forInvoice': 'Per Fattura {invoice}',
  'payments.customer.paymentMade': 'Pagamento effettuato',
  'payments.customer.recordCreated': 'Record creato',
  'payments.customer.loadError': 'Impossibile caricare lo storico pagamenti',
  'payments.customer.downloadError': 'Impossibile scaricare la ricevuta',
  'payments.noPayments': 'Nessun Pagamento Trovato',
  'payments.noPaymentsDescription': 'Non hai ancora effettuato pagamenti. Lo storico dei pagamenti apparirà qui una volta effettuato il primo pagamento.',
  'payments.remaining': 'Rimanente',
  'payments.total': 'Totale',
  'payments.paid': 'Pagato',
  'payments.outstanding': 'In Sospeso',
  'payments.fullAmount': 'Importo Completo',
  'payments.halfAmount': 'Metà',
  'payments.refund': 'Rimborso',
  'payments.maximumAmount': 'Massimo: €{amount}',
  'payments.useNegativeForRefunds': 'Usa negativo per rimborsi',
  'payments.amountExceedsBalance': 'L\'importo supera il saldo in sospeso',
  'payments.selectPaymentMethod': 'Seleziona metodo di pagamento',
  'payments.addNote': 'Aggiungi note su questo pagamento...',
  'payments.method.cash': 'Contanti',
  'payments.method.card': 'Carta',
  'payments.method.creditCard': 'Carta di Credito',
  'payments.method.bankTransfer': 'Bonifico Bancario',
  'payments.method.bank': 'Bonifico Bancario',
  'payments.method.other': 'Altro',
  'payments.dialog.recordingForRequest': 'Registrazione pagamento per richiesta di pagamento',
  'payments.dialog.amountLine': 'Importo: EUR {amount}',
  'payments.dialog.recordForInvoice': 'Registra un pagamento per questa fattura (Residuo: EUR {amount})',
  'payments.dialog.paymentAmount': 'Importo Pagamento',
  'payments.dialog.amountPlaceholder': '0.00',
  'payments.dialog.requestAmountWithRefund': 'Importo richiesta: EUR {amount} | Usa negativo per rimborsi',
  'payments.dialog.outstandingWithRefund': 'Residuo: EUR {amount} | Usa negativo per rimborsi',
  'payments.dialog.amountExceedsRequest': "L'importo supera l'importo della richiesta",
  'payments.dialog.fullRequest': 'Richiesta completa',
  'payments.dialog.fullOutstanding': 'Residuo completo',
  'payments.dialog.refundFixed': 'Rimborso EUR {amount}',
  'payments.dialog.noteOptional': 'Nota (Opzionale)',
  'payments.dialog.cancel': 'Annulla',
  'payments.dialog.recording': 'Registrazione...',

  // Payment receipts
  'receipt.title': 'Ricevuta di Pagamento',
  'receipt.number': 'Numero Ricevuta',
  'receipt.paymentFor': 'Pagamento per Fattura',
  'receipt.paymentAmount': 'Importo Pagamento',
  'receipt.paymentMethod': 'Metodo di Pagamento',
  'receipt.paymentDate': 'Data Pagamento',
  'receipt.invoiceTotal': 'Totale Fattura',
  'receipt.amountPaid': 'Importo Pagato',
  'receipt.remainingBalance': 'Saldo Rimanente',
  'receipt.thankYou': 'Grazie per il tuo pagamento',

  // Invoice payments tab
  'invoice.payments.title': 'Pagamenti',
  'invoice.payments.summary': 'Riepilogo Pagamenti',
  'invoice.payments.totalInvoiced': 'Totale Fatturato',
  'invoice.payments.totalPaid': 'Totale Pagato',
  'invoice.payments.totalOutstanding': 'Totale in Sospeso',
  'invoice.payments.remainingToInvoice': 'Rimanente da Fatturare',
  'invoice.payments.addPayment': 'Aggiungi Pagamento',
  'invoice.payments.noPayments': 'Nessun pagamento registrato',
  'invoice.payments.paymentProgress': 'Progresso Pagamenti',

  // Invoices page toasts
  'invoices.toast.fetchError': 'Impossibile recuperare le fatture',
  'invoices.toast.printWarning': 'Fattura stampata ma aggiornamento stato fallito',
  'invoices.toast.printed': 'Fattura Stampata',
  'invoices.toast.printedDraftDescription': 'Fattura stampata e stato cambiato in Emessa',
  'invoices.toast.printedDescription': 'Fattura aperta in nuova finestra. Usa la funzione di stampa del browser per salvare come PDF.',
  'invoices.toast.openError': 'Impossibile aprire la fattura',
  'invoices.toast.comingSoon': 'Prossimamente',
  'invoices.toast.pdfComingSoon': 'La funzionalità di download PDF sarà disponibile a breve.',
  'invoices.toast.archived': 'Fattura archiviata con successo',
  'invoices.toast.archiveError': 'Impossibile archiviare la fattura',
  'invoices.toast.deleteTitle': 'Elimina Fattura',
  'invoices.toast.deleteConfirm': 'Sei sicuro di voler eliminare questa fattura?',
  'invoices.toast.deleteWarning': 'La fattura verrà eliminata e potrà essere ripristinata solo contattando il supporto.',
  'invoices.toast.deleteButton': 'Elimina Fattura',
  'invoices.toast.cancel': 'Annulla',
  'invoices.toast.printInvoiceTitle': 'Stampa Fattura',
  'invoices.invoiceDetails': 'Dettagli Fattura',

  // InvoiceDetailDialog toasts
  'invoices.detail.updated': 'Fattura aggiornata con successo',
  'invoices.detail.updateError': 'Impossibile aggiornare la fattura',
  'invoices.detail.paymentDeleted': 'Pagamento eliminato con successo',
  'invoices.detail.paymentDeleteError': 'Impossibile eliminare il pagamento',
  'invoices.detail.deleted': 'Fattura eliminata con successo',
  'invoices.detail.deleteError': 'Impossibile eliminare la fattura',
  'invoices.detail.orderLabel': 'Ordine:',
  'invoices.detail.customerInformation': 'Informazioni Cliente',
  'invoices.detail.nameLabel': 'Nome:',
  'invoices.detail.phoneLabel': 'Telefono:',
  'invoices.detail.notesTitle': 'Note',
  'invoices.detail.dialogTitle': 'Fattura {number}',
  'invoices.detail.orderNumber': 'Ordine #{orderId}',
  'invoices.detail.notesPlaceholder': 'Note interne su questa fattura...',
  'invoices.detail.outstandingAmount': 'Residuo: EUR {amount}',
  'invoices.detail.saveChanges': 'Salva modifiche',

  // Invoices list page
  'invoices.page.title': 'Fatture',
  'invoices.page.subtitle': 'Gestisci fatture, saldi e stato dei pagamenti.',
  'invoices.page.createInvoice': 'Crea Fattura',
  'invoices.page.searchPlaceholder': 'Cerca fatture, ordini, clienti...',
  'invoices.page.filters': 'Filtri',
  'invoices.page.columns': 'Colonne',
  'invoices.page.clearAll': 'Cancella tutto',
  'invoices.page.sort.placeholder': 'Ordina per',
  'invoices.page.sort.issueNewest': 'Data Emissione: Più Recenti',
  'invoices.page.sort.issueOldest': 'Data Emissione: Più Vecchie',
  'invoices.page.sort.dueLatest': 'Data Scadenza: Più Lontane',
  'invoices.page.sort.dueEarliest': 'Data Scadenza: Più Vicine',
  'invoices.page.sort.amountHighLow': 'Importo: Alto-Basso',
  'invoices.page.sort.amountLowHigh': 'Importo: Basso-Alto',
  'invoices.page.sort.outstandingHighLow': 'Residuo: Alto-Basso',
  'invoices.page.sort.outstandingLowHigh': 'Residuo: Basso-Alto',
  'invoices.page.sort.statusAz': 'Stato: A-Z',
  'invoices.page.filter.status': 'Stato',
  'invoices.page.filter.issueDate': 'Data Emissione',
  'invoices.page.filter.dueDate': 'Data Scadenza',
  'invoices.page.filter.invoiceTotal': 'Totale Fattura',
  'invoices.page.filter.outstandingBalance': 'Saldo Residuo',
  'invoices.page.filter.overdueOnly': 'Solo scadute',
  'invoices.page.filter.minCurrency': 'Min EUR',
  'invoices.page.filter.maxCurrency': 'Max EUR',
  'invoices.page.filter.clear': 'Cancella',
  'invoices.page.pagination.showing': 'Mostrando {from}-{to} di {total}',
  'invoices.page.pagination.perPage': '{count} / pagina',
  'invoices.page.pagination.pageOf': 'Pagina {page} / {total}',

  // Invoices table
  'invoices.table.column.invoiceNumber': 'Fattura #',
  'invoices.table.column.orderNumber': 'Ordine #',
  'invoices.table.column.customer': 'Cliente',
  'invoices.table.column.issueDate': 'Data Emissione',
  'invoices.table.column.dueDate': 'Data Scadenza',
  'invoices.table.column.total': 'Totale',
  'invoices.table.column.outstanding': 'Residuo',
  'invoices.table.column.status': 'Stato',
  'invoices.table.action.printHtml': 'HTML (Stampa)',
  'invoices.table.action.printPdfSoon': 'PDF (Prossimamente)',
  'invoices.status.draft': 'Bozza',
  'invoices.status.issued': 'Emessa',
  'invoices.status.partPaid': 'Parzialmente pagata',
  'invoices.status.paid': 'Pagata',

  // Payment Requests page
  'paymentRequests.page.title': 'Richieste di Pagamento',
  'paymentRequests.page.subtitle': 'Monitora richieste inviate, scadenze e importi in sospeso.',
  'paymentRequests.page.searchPlaceholder': 'Cerca per richiesta, fattura, ordine o nota',
  'paymentRequests.page.filters': 'Filtri',
  'paymentRequests.page.columns': 'Colonne',
  'paymentRequests.page.clearAll': 'Cancella tutto',
  'paymentRequests.page.sort.placeholder': 'Ordina per',
  'paymentRequests.page.sort.createdNewest': 'Creato: Più Recenti',
  'paymentRequests.page.sort.createdOldest': 'Creato: Più Vecchie',
  'paymentRequests.page.sort.dueLatest': 'Data Scadenza: Più Lontane',
  'paymentRequests.page.sort.dueEarliest': 'Data Scadenza: Più Vicine',
  'paymentRequests.page.sort.amountHighLow': 'Importo: Alto-Basso',
  'paymentRequests.page.sort.amountLowHigh': 'Importo: Basso-Alto',
  'paymentRequests.page.sort.statusAz': 'Stato: A-Z',
  'paymentRequests.page.column.request': 'Richiesta',
  'paymentRequests.page.column.invoice': 'Fattura',
  'paymentRequests.page.column.order': 'Ordine',
  'paymentRequests.page.column.customer': 'Cliente',
  'paymentRequests.page.column.amount': 'Importo',
  'paymentRequests.page.column.dueDate': 'Data Scadenza',
  'paymentRequests.page.column.status': 'Stato',
  'paymentRequests.page.column.created': 'Creato',
  'paymentRequests.page.filter.status': 'Stato',
  'paymentRequests.page.filter.createdDate': 'Data Creazione',
  'paymentRequests.page.filter.dueDate': 'Data Scadenza',
  'paymentRequests.page.filter.amount': 'Importo',
  'paymentRequests.page.filter.minAmount': 'Min EUR',
  'paymentRequests.page.filter.maxAmount': 'Max EUR',
  'paymentRequests.page.filter.clear': 'Cancella',
  'paymentRequests.page.loading': 'Caricamento richieste di pagamento...',
  'paymentRequests.page.empty': 'Nessuna richiesta di pagamento trovata con i filtri correnti.',
  'paymentRequests.page.pagination.showing': 'Mostrando {from}-{to} di {total}',
  'paymentRequests.page.pagination.perPage': '{count} / pagina',
  'paymentRequests.page.pagination.pageOf': 'Pagina {page} / {total}',
  'paymentRequests.status.pending': 'In Attesa',
  'paymentRequests.status.sent': 'Inviata',
  'paymentRequests.status.paid': 'Pagata',
  'paymentRequests.status.overdue': 'Scaduta',

  // Payments page
  'payments.page.title': 'Pagamenti',
  'payments.page.subtitle': 'Monitora storico pagamenti, metodi e stato di regolamento.',
  'payments.page.searchPlaceholder': 'Cerca per ricevuta, metodo o nota',
  'payments.page.filters': 'Filtri',
  'payments.page.columns': 'Colonne',
  'payments.page.clearAll': 'Cancella tutto',
  'payments.page.sort.placeholder': 'Ordina per',
  'payments.page.sort.paymentDateNewest': 'Data Pagamento: Più Recenti',
  'payments.page.sort.paymentDateOldest': 'Data Pagamento: Più Vecchie',
  'payments.page.sort.createdNewest': 'Creato: Più Recenti',
  'payments.page.sort.createdOldest': 'Creato: Più Vecchie',
  'payments.page.sort.amountHighLow': 'Importo: Alto-Basso',
  'payments.page.sort.amountLowHigh': 'Importo: Basso-Alto',
  'payments.page.sort.receiptHighLow': 'Ricevuta: Alto-Basso',
  'payments.page.sort.receiptLowHigh': 'Ricevuta: Basso-Alto',
  'payments.page.column.receipt': 'Ricevuta',
  'payments.page.column.invoice': 'Fattura',
  'payments.page.column.amount': 'Importo',
  'payments.page.column.method': 'Metodo',
  'payments.page.column.paymentDate': 'Data Pagamento',
  'payments.page.column.status': 'Stato',
  'payments.page.column.request': 'Richiesta',
  'payments.page.column.created': 'Creato',
  'payments.page.filter.status': 'Stato',
  'payments.page.filter.method': 'Metodo',
  'payments.page.filter.paymentDate': 'Data Pagamento',
  'payments.page.filter.createdDate': 'Data Creazione',
  'payments.page.filter.amount': 'Importo',
  'payments.page.filter.receiptNumber': 'Numero Ricevuta',
  'payments.page.filter.requestLink': 'Collegamento Richiesta Pagamento',
  'payments.page.filter.minAmount': 'Min EUR',
  'payments.page.filter.maxAmount': 'Max EUR',
  'payments.page.filter.clear': 'Cancella',
  'payments.page.requestLink.withRequest': 'Con richiesta',
  'payments.page.requestLink.withoutRequest': 'Senza richiesta',
  'payments.page.loading': 'Caricamento pagamenti...',
  'payments.page.empty': 'Nessun pagamento trovato con i filtri correnti.',
  'payments.page.pagination.showing': 'Mostrando {from}-{to} di {total}',
  'payments.page.pagination.perPage': '{count} / pagina',
  'payments.page.pagination.pageOf': 'Pagina {page} / {total}',
  'payments.status.completed': 'Completato',
  'payments.status.paid': 'Pagato',
  'payments.status.pending': 'In Attesa',
  'payments.status.failed': 'Fallito',
  'payments.status.refunded': 'Rimborsato',
};
